import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { ISetLabelsAction } from '~src/spacesPlatform/models/actionNames';

import { Messages } from '../../../codegen/Localize';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { SetDataQualityEntityAction, SetDataQualityTriggerAction } from '../dataQuality/SetDataQualityEntityAction';
import { SetCertificationEntityAction } from './SetCertificationEntityAction';
import { SetCustomLabelEntityAction } from './SetCustomLabelEntityAction';
import { SetSensitiveLabelEntityAction } from './SetSensitiveLabelEntityAction';

export const DataLabelsSubmenu: IEntityAction<IContentInfo, ISetLabelsAction> = {
    name: EntityActionNames.DataLabelsSubmenu,
    translateName: Messages.dataLabels_action_submenu,
    isVisible: (items, state) =>
        SetDataQualityEntityAction.isVisible(items, state) ||
        SetDataQualityTriggerAction.isVisible(items, state) ||
        SetCertificationEntityAction.isVisible(items, state) ||
        SetCustomLabelEntityAction.isVisible(items, state) ||
        SetSensitiveLabelEntityAction.isVisible(items, state),
    isClickable: (a, t, s) =>
        SetDataQualityEntityAction.isClickable(a, t, s) ||
        SetDataQualityTriggerAction.isClickable(a, t, s) ||
        SetCertificationEntityAction.isClickable(a, t, s) ||
        SetCustomLabelEntityAction.isClickable(a, t, s) ||
        SetSensitiveLabelEntityAction.isClickable(a, t, s),
    createReduxAction: () => null // The menu widget doesn't let "submenu" items be clicked
  };


